export default () => {
    const host = window.location.host;
    return host.includes('test') || host.includes('localhost') ? 'test' : 'prod';
};